import script from "./QPageTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./QPageTitle.vue?vue&type=script&setup=true&lang=ts"

import "./QPageTitle.vue?vue&type=style&index=0&id=47d7e109&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47d7e109"]])

export default __exports__